import React from "react";
import PageChrome, { INK, BLUE } from "./components/PageChrome";

const CONTACT_EMAIL = "hola@thedebtguy.com";
const UPDATED = "junio de 2026";

const Section = ({ n, title, children }) => (
  <section style={{ marginTop: 40 }} data-testid={`privacy-section-${n}`}>
    <h2 className="cg-h3" style={{ marginBottom: 14 }}>
      <span style={{ color: BLUE, marginRight: 12 }}>{n}.</span>
      {title}
    </h2>
    <div style={{ fontSize: 15.5, lineHeight: 1.75, color: INK, opacity: 0.86 }}>{children}</div>
  </section>
);

const P = ({ children }) => <p style={{ margin: "0 0 14px" }}>{children}</p>;
const UL = ({ items }) => (
  <ul style={{ margin: "0 0 14px", paddingLeft: 22 }}>
    {items.map((it, i) => (
      <li key={i} style={{ marginBottom: 8 }}>{it}</li>
    ))}
  </ul>
);

export default function Privacidad() {
  return (
    <PageChrome testid="privacy-page">
      <div style={{ maxWidth: 820, margin: "0 auto", padding: "72px 24px 100px" }}>
        <p className="cg-mono cg-eyebrow" data-testid="privacy-eyebrow">Legal · Privacidad</p>
        <h1 className="cg-h1" style={{ marginTop: 14 }}>Aviso de Privacidad</h1>
        <p style={{ marginTop: 18, fontSize: 14, opacity: 0.55 }} className="cg-mono">
          Última actualización: {UPDATED}
        </p>

        <Section n={1} title="Responsable del tratamiento">
          <P>
            The Debt Guy, marca personal operada por Ernesto Gómez Berjón (en adelante,
            "The Debt Guy", "nosotros"), es responsable del tratamiento de tus datos
            personales conforme al presente Aviso de Privacidad. Para cualquier asunto
            relacionado con tus datos, puedes contactarnos en{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} className="cg-link" style={{ color: BLUE }}>
              {CONTACT_EMAIL}
            </a>.
          </P>
        </Section>

        <Section n={2} title="Datos personales que recabamos">
          <P>Podemos recabar las siguientes categorías de datos cuando interactúas con nuestro sitio y servicios:</P>
          <UL items={[
            "Datos de identificación y contacto: nombre, correo electrónico, empresa, país.",
            "Datos sobre tu operación o proyecto que compartes voluntariamente en formularios de aplicación.",
            "Datos de facturación y pago (procesados de forma segura por nuestro proveedor de pagos; no almacenamos números de tarjeta completos).",
            "Datos de uso y navegación: dirección IP, tipo de dispositivo, páginas visitadas y cookies.",
          ]} />
        </Section>

        <Section n={3} title="Finalidades del tratamiento">
          <P>Utilizamos tus datos personales para las siguientes finalidades:</P>
          <UL items={[
            "Prestarte los productos y servicios que adquieres (cursos, toolkit, membresías, programas y mandatos 1:1).",
            "Enviarte nuestro newsletter y comunicaciones relacionadas cuando te suscribes.",
            "Procesar pagos, suscripciones y emitir comprobantes.",
            "Dar seguimiento a aplicaciones a cohortes, certificaciones y servicios de estructuración.",
            "Mejorar el sitio, la experiencia de usuario y nuestras ofertas.",
            "Cumplir con obligaciones legales y fiscales aplicables.",
          ]} />
        </Section>

        <Section n={4} title="Transferencias de datos">
          <P>
            Podemos compartir tus datos con proveedores que nos ayudan a operar (por ejemplo,
            procesadores de pago, plataformas de envío de correo, herramientas de analítica y
            hosting), siempre bajo obligaciones de confidencialidad y únicamente para las
            finalidades descritas. No vendemos tus datos personales a terceros.
          </P>
        </Section>

        <Section n={5} title="Derechos ARCO">
          <P>
            Tienes derecho a Acceder, Rectificar, Cancelar u Oponerte al tratamiento de tus datos
            personales (derechos ARCO), así como a revocar tu consentimiento. Para ejercerlos,
            envía tu solicitud a{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} className="cg-link" style={{ color: BLUE }}>
              {CONTACT_EMAIL}
            </a>{" "}
            indicando tu nombre y el derecho que deseas ejercer. Responderemos en un plazo razonable.
          </P>
        </Section>

        <Section n={6} title="Cookies y tecnologías similares">
          <P>
            Usamos cookies y tecnologías similares para recordar tus preferencias, medir el uso del
            sitio y mejorar el rendimiento. Puedes deshabilitar las cookies desde la configuración
            de tu navegador; algunas funciones podrían dejar de operar correctamente.
          </P>
        </Section>

        <Section n={7} title="Conservación y seguridad">
          <P>
            Conservamos tus datos durante el tiempo necesario para cumplir las finalidades descritas
            y las obligaciones legales aplicables. Aplicamos medidas técnicas y organizativas
            razonables para proteger tu información contra accesos no autorizados, pérdida o
            alteración.
          </P>
        </Section>

        <Section n={8} title="Cambios al Aviso de Privacidad">
          <P>
            Podemos actualizar este Aviso de Privacidad en cualquier momento. La versión vigente
            siempre estará disponible en esta página, con su fecha de última actualización.
          </P>
        </Section>

        <Section n={9} title="Contacto">
          <P>
            Si tienes dudas sobre este Aviso o el tratamiento de tus datos, escríbenos a{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} className="cg-link" style={{ color: BLUE }}>
              {CONTACT_EMAIL}
            </a>.
          </P>
        </Section>
      </div>
    </PageChrome>
  );
}
